import React from "react";
import "./Uploadbanner.css";
import Camera from "../../../../../../assets/icons/Camera.svg";

const Uploadbanner = ({width, height, aspectRatio}) => {
  return (
    <div className="upload-box">
      <div className="upload-area">
        <div>
          <img 
            src={Camera} 
            alt="Camera" 
            className="camera-icon" 
            style={{ paddingTop: '10px' }}
          />
          <p style={{ cursor: 'pointer', paddingTop: '10px' }} className="sub-text">
            <span className="hide-on-mobile">Drag & drop your files here or </span>
            <span className="choose-text">choose files</span>
          </p>
          <p className="file-info" >
            <div style={{ marginBottom: '10px' }}>
              Image must be {' '}
              <strong style={{ fontSize: '14px', fontWeight: '600', color: '#3E3E3E' }}>
              {width || '1280'}
              </strong> pixels wide by{' '}
              <strong style={{ fontSize: '14px', fontWeight: '600', color: '#3E3E3E' }}>
              {height || '720'}
              </strong> pixels tall, maintaining an aspect ratio of{' '}
              <strong style={{ fontSize: '14px', fontWeight: '600', color: '#3E3E3E' }}>
              {aspectRatio || '16:9'}
              </strong>.
              <br />
            </div>
            You can only upload JPEG, JPG, PNG formats up to{' '}
            10MB.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Uploadbanner;